.wrapper {
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-height: 78px;
}

.label {
	margin-bottom: unset !important;
}

.trigger {
	composes: body-2 from global;
	position: relative;
	background-color: var(--elevation-default);
	border: solid 1px var(--border-primary);
	color: var(--content-primary);
	border-radius: 8px;
	width: 100%;
	min-height: 38px;
	padding: 4px 32px 4px 12px;
	display: flex;
	align-items: center;
}

.trigger[data-hovered]:not([data-focus-within]) {
	border: solid 1px var(--border-hover);
}

.trigger[data-focus-within] {
	outline: var(--focus-outline);
}

.invalidField,
.invalidField[data-hovered]:not([data-focus-within]) {
	border: solid 1px var(--border-error);
	color: var(--content-error);
}

.trigger[data-disabled] {
	opacity: 0.5;
	cursor: not-allowed;
	background-color: var(--elevation-low);
}

.triggerButton {
	position: absolute;
	inset: 0;
	background: transparent;
	border: none;
	padding: 0 12px 0 12px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	cursor: pointer;
	color: var(--content-tertiary);
	z-index: 0;
}

.triggerButton[data-focus-visible] {
	outline: none;
}

.arrow {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 8px;
	height: 5px;
	transition: rotate 0.3s;
}

.wrapper[data-open] .arrow {
	rotate: 180deg;
}

.value {
	flex: 1;
	min-width: 0;
	position: relative;
	z-index: 1;
	pointer-events: none;
	display: flex;
	align-items: center;
}

.placeholder {
	color: var(--content-tertiary);
}

.invalidField .placeholder {
	color: var(--content-error);
}

.tagList {
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
	width: 100%;
}

.tag {
	composes: caption from global;
	display: inline-flex;
	align-items: center;
	gap: 4px;
	background-color: var(--elevation-medium);
	border: 1px solid var(--border-primary);
	border-radius: 50px;
	padding: 2px 4px 2px 10px;
	outline: none;
	cursor: default;
	pointer-events: auto;
}

.tag[data-focus-visible] {
	outline: var(--focus-outline);
}

.tagRemove {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 14px;
	height: 14px;
	padding: 0;
	color: var(--content-tertiary);
	background: transparent;
	border: none;
	cursor: pointer;
	border-radius: 50%;
	pointer-events: auto;
}

.tagRemove[data-hovered] {
	color: var(--content-primary);
}

.tagRemove svg {
	width: 12px;
	height: 12px;
}

.errorMessage {
	color: var(--content-error);
}

.description {
	color: var(--content-tertiary);
}

.popover {
	width: var(--trigger-width);
	background-color: var(--elevation-default);
	border: solid 1px var(--border-primary);
	border-radius: 8px;
	box-shadow: var(--box-shadow);
	overflow: hidden;
	outline: none;
	max-height: 260px;
	display: flex;
	flex-direction: column;
}

.listbox {
	outline: none;
	overflow: auto;
	max-height: 260px;
}

.option {
	padding: 12px;
	outline: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 8px;
	color: var(--content-primary);
}

.option[data-hovered],
.option[data-focused] {
	background-color: var(--elevation-medium);
}

.checkbox {
	width: 16px;
	height: 16px;
	border-radius: 3px;
	border: 1.4px solid var(--border-primary);
	background-color: var(--background-primary);
	flex-shrink: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.option[data-hovered] .checkbox {
	border-color: var(--border-hover);
}

.tick {
	width: 10px;
	height: 10px;
	color: var(--background-primary);
	visibility: hidden;
}

.option[data-selected] .checkbox {
	background-color: var(--background-secondary);
	border-color: var(--background-primary);
}

.option[data-selected] .tick {
	visibility: visible;
}
